import { useEffect, useRef } from "react";
import * as d3 from "d3";

export const EscalonesGrafico = ({
    cantidadEscalones = 0,
    volMeseta = 0,
    volPrimerEscalon = 0,
    volSegundoEscalon = 0,
    duracionHoras = 0,
    volumen = 0,
}) => {
    const svgRef = useRef(null);

    useEffect(() => {
        const HEIGHT = cantidadEscalones * 100;

        const H = cantidadEscalones === 2 ? [80, 80, 120, 80, 80] : [80, 120, 80];
        const VSTEP = 40;
        const TOTAL_W = H.reduce((a, b) => a + b, 0);

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove();

        const VB_WIDTH = Math.max(480, TOTAL_W + 80);
        svg
            .attr("width", "100%")
            .attr("height", HEIGHT)
            .attr("viewBox", `0 0 ${VB_WIDTH} ${HEIGHT}`)
            .attr("preserveAspectRatio", "xMidYMid meet");

        const g = svg.append("g");

        const origin = {
            x: (VB_WIDTH - TOTAL_W) / 2,
            y: HEIGHT - 40,
        };

        const pts = [];
        let x = origin.x;
        let y = origin.y;

        pts.push([x, y]);

        if (cantidadEscalones === 2) {
            x += H[0]; pts.push([x, y]);
            y -= VSTEP; pts.push([x, y]);
            x += H[1]; pts.push([x, y]);
            y -= VSTEP; pts.push([x, y]);
            x += H[2]; pts.push([x, y]);
            y += VSTEP; pts.push([x, y]);
            x += H[3]; pts.push([x, y]);
            y += VSTEP; pts.push([x, y]);
            x += H[4]; pts.push([x, y]);
        } else {
            x += H[0]; pts.push([x, y]);
            y -= VSTEP; pts.push([x, y]);
            x += H[1]; pts.push([x, y]);
            y += VSTEP; pts.push([x, y]);
            x += H[2]; pts.push([x, y]);
        }

        g.append("path")
            .attr("d", d3.line()(pts))
            .attr("fill", "none")
            .attr("stroke", "#000")
            .attr("stroke-width", 3)
            .attr("stroke-linejoin", "round")
            .attr("stroke-linecap", "round");

        const LABEL_DY_TOP = -10;
        const LABEL_DY_BOTTOM = 20;

        if (cantidadEscalones === 2) {
            const levels = { base: origin.y, mid: origin.y - VSTEP, top: origin.y - 2 * VSTEP };
            const cxs = [
                origin.x + H[0] / 2,
                origin.x + H[0] + H[1] / 2,
                origin.x + H[0] + H[1] + H[2] / 2,
                origin.x + H[0] + H[1] + H[2] + H[3] / 2,
                origin.x + H[0] + H[1] + H[2] + H[3] + H[4] / 2,
            ];

            const segments = [
                { cx: cxs[0], cy: levels.base, topText: `${volPrimerEscalon} ml/h`, bottomText: "30'" },
                { cx: cxs[1], cy: levels.mid, topText: `${volSegundoEscalon} ml/h`, bottomText: "30'" },
                { cx: cxs[2], cy: levels.top, topText: `${volMeseta} ml/h`, bottomText: `${duracionHoras}H` },
                { cx: cxs[3], cy: levels.mid, topText: `${volSegundoEscalon} ml/h`, bottomText: "30'" },
                { cx: cxs[4], cy: levels.base, topText: `${volPrimerEscalon} ml/h`, bottomText: "30'" },
            ];

            g.selectAll("text.top")
                .data(segments).enter().append("text")
                .attr("x", d => d.cx).attr("y", d => d.cy + LABEL_DY_TOP)
                .attr("text-anchor", "middle").attr("font-size", 12).attr("fill", "#222")
                .text(d => d.topText);

            g.selectAll("text.bottom")
                .data(segments).enter().append("text")
                .attr("x", d => d.cx).attr("y", d => d.cy + LABEL_DY_BOTTOM)
                .attr("text-anchor", "middle").attr("font-size", 12).attr("fill", "#222")
                .attr("font-weight", d => (d.bottomText === "30'" ? 700 : 400))
                .text(d => d.bottomText);

            g.append("text")
                .attr("x", segments[2].cx)
                .attr("y", segments[2].cy + 84)
                .attr("text-anchor", "middle")
                .attr("font-size", 14)
                .attr("font-weight", 600)
                .attr("fill", "#000")
                .text(`V:${volumen} ml`);
        } else {
            const levels = { base: origin.y, mid: origin.y - VSTEP };
            const cxs = [
                origin.x + H[0] / 2,
                origin.x + H[0] + H[1] / 2,
                origin.x + H[0] + H[1] + H[2] / 2,
            ];

            const segments = [
                { cx: cxs[0], cy: levels.base, topText: `${volPrimerEscalon} ml/h`, bottomText: "30'" },
                { cx: cxs[1], cy: levels.mid, topText: `${volMeseta} ml/h`, bottomText: `${duracionHoras}H` },
                { cx: cxs[2], cy: levels.base, topText: `${volPrimerEscalon} ml/h`, bottomText: "30'" },
            ];

            g.selectAll("text.top")
                .data(segments).enter().append("text")
                .attr("x", d => d.cx).attr("y", d => d.cy + LABEL_DY_TOP)
                .attr("text-anchor", "middle").attr("font-size", 12).attr("fill", "#222")
                .text(d => d.topText);

            g.selectAll("text.bottom")
                .data(segments).enter().append("text")
                .attr("x", d => d.cx).attr("y", d => d.cy + LABEL_DY_BOTTOM)
                .attr("text-anchor", "middle").attr("font-size", 12).attr("fill", "#222")
                .attr("font-weight", d => (d.bottomText === "30'" ? 700 : 400))
                .text(d => d.bottomText);

            g.append("text")
                .attr("x", segments[1].cx)
                .attr("y", segments[1].cy + 44)
                .attr("text-anchor", "middle")
                .attr("font-size", 14)
                .attr("font-weight", 600)
                .attr("fill", "#000")
                .text(`V:${volumen} ml`);
        }
    }, [cantidadEscalones, volMeseta, volPrimerEscalon, volSegundoEscalon, duracionHoras, volumen]);

    if (
        !cantidadEscalones ||
        !volumen ||
        !duracionHoras ||
        duracionHoras < 10 ||
        duracionHoras > 20
    ) {
        return null;
    }

    return <svg ref={svgRef} />;
}
